import { Dimensions } from 'react-native';
var _a = Dimensions.get('window'), width = _a.width, height = _a.height;
// Base dimensions based on Zeplin project
var baseWidth = 375;
var baseHeight = 667;
var horizontalScale = function (size) { return (width / baseWidth) * size; };
var verticalScale = function (size) { return (height / baseHeight) * size; };
// since web project's window deimensions not same as simulator's dimension, we needs to turnoff scale if it's used in web project
var moderateScale = function (size, scaleFactor, scaledByWindow) {
    if (scaleFactor === void 0) { scaleFactor = 0.5; }
    if (scaledByWindow === void 0) { scaledByWindow = false; }
    return scaledByWindow ? size + (horizontalScale(size) - size) * scaleFactor : size;
};
export { horizontalScale, verticalScale, moderateScale };
